// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';

import './ShipDetailModal.css';

// React Modalで実装
import Modal from 'react-modal';

import { useEffect } from 'react';
import { useTranslation } from "react-i18next";

const ShipDetailModal = ({ statusChangeModalIsOpen, setStatusChangeModalIsOpen, shipInfo, setShipInfo}) => {
    const { t } = useTranslation();
    
    const [shipDetailPage, setShipDetailPage] = useState(1);
    
    const moveNextPage = () => {
        setShipDetailPage(2);
    }

    const movePrevPage = () => {
        setShipDetailPage(1);
    }

    const completeShip = () => {
        let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
        if (xsrfToken) {
            xsrfToken = xsrfToken.split('=')[1]
        }
        let token = document.cookie.split('; ').find(row => row.startsWith('token'));
        if (token) {
            token = token.split('=')[1]
        }
        fetch(`${process.env.REACT_APP_API_URL}/api/ship/status/${shipInfo.id}`, {
            method: 'POST',
            cache: 'no-store',
            headers: {
                'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                'Bearer': decodeURIComponent(token),
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                status: shipDetail.status ? shipDetail.status : 1,
                shipment_type: shipDetail.shipment_type ? shipDetail.shipment_type : 1,
                tracking_number: shipDetail.tracking_number ? shipDetail.tracking_number : "",
                single_tracking_number: shipDetail.single_tracking_number ? shipDetail.single_tracking_number : "",
                note: shipDetail.note ? shipDetail.note : "",
            })
        })
        .then(res => {
            if(res.ok) {
                return res.json();
            } else if (res.status === 404) {
                setShipInfo({
                    ...shipInfo,
                    status: 3,
                });
                alert(t('ship_detail_modal.error'));
                closeAndResetModal();
                throw new Error(t('ship_detail_modal.error'));
            } else {
                alert(t('common.error'));
                throw new Error(t('common.error'));
            }
        })
        .then(data => {
            if(!data.errors) {
                setShipInfo({
                    ...shipInfo,
                    status: shipDetail.status ? shipDetail.status : 1,
                });
                setStatusChangeModalIsOpen(false);
                setShipDetailPage(1);

                alert(t('ship_detail_modal.changed'));
                closeAndResetModal();
            } else {
                alert(t('common.error'));
            }
        })
        .catch(err => {
            console.log(err);
        })
    }

    const closeAndResetModal = () => {
        setStatusChangeModalIsOpen(false);
        setShipDetailPage(1);
    }

    const [shipDetail, setShipDetail] = useState({
        id: '',
        status: 1,
        shipment_type: 1,
        tracking_number: "",
        single_tracking_number: "",
        note: ""
    });

    useEffect(() => {
        setShipDetail({
            id: shipInfo.id,
            status: shipInfo.status ? shipInfo.status : 1,
            shipment_type: shipInfo.shipment_type ? shipInfo.shipment_type : 1,
            tracking_number: shipInfo.tracking_number ? shipInfo.tracking_number : "",
            single_tracking_number: shipInfo.single_tracking_number ? shipInfo.single_tracking_number : "",
            note: shipInfo.note ? shipInfo.note : ""
        });
    }, [shipInfo]);

    return (
        <>
            { shipDetailPage === 1 &&
                <>
                    <ShipDetailModal1
                        modalIsOpen = {statusChangeModalIsOpen}
                        closeModal = {closeAndResetModal}
                        moveNextPage = {moveNextPage}
                        shipDetail={shipDetail}
                        setShipDetail={setShipDetail}
                    />
                </>
            }
            { shipDetailPage === 2 &&
                <>
                    <ShipDetailModal2
                        modalIsOpen = {statusChangeModalIsOpen}
                        closeModal = {closeAndResetModal}
                        movePrevPage = {movePrevPage}
                        completeShip = {completeShip}
                        shipDetail={shipDetail}
                        setShipDetail={setShipDetail}
                    />
                </>
            }
        </>
    );
}

export default ShipDetailModal;


const ShipDetailModal1 = ({modalIsOpen, closeModal, moveNextPage, shipDetail, setShipDetail}) => {
    const { t } = useTranslation();
    return (
        <>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="ship-detail-modal"
            overlayClassName="ship-detail-modal-overlay"
            contentLabel="Example Modal"
        >
            <div className="ship-detail-modal-title">{t('ship_detail_modal.title')}</div>
            <div className='progressbar-mini-box'>
                <ul className="progressbar-mini">
                    <li className="active"></li>
                    <li></li>
                </ul>
            </div>
            <div className="clearfix"></div>
            <div className="ship-detail-modal-form">
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.id')}</div>
                <div className="ship-detail-modal-form-content">{shipDetail.id}</div>
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.status')}</div>
                <div className="ship-detail-modal-form-content">
                    <select className="ship-detail-modal-form-content-select" name="status" value={shipDetail.status} onChange={e => setShipDetail({...shipDetail, status: e.target.value})}>
                        <option value="1">{t('ship_detail_modal.status1')}</option>
                        <option value="2">{t('ship_detail_modal.status2')}</option>
                        <option value="3">{t('ship_detail_modal.status3')}</option>
                        <option value="4">{t('ship_detail_modal.status4')}</option>
                        <option value="5">{t('ship_detail_modal.status5')}</option>
                        <option value="6">{t('ship_detail_modal.status6')}</option>
                        <option value="7">{t('ship_detail_modal.status7')}</option>
                    </select>
                </div>
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.how')}</div>
                <div className="ship-detail-modal-form-content">
                    <select className="ship-detail-modal-form-content-select" name="shipment_type" value={shipDetail.shipment_type} onChange={e => setShipDetail({...shipDetail, shipment_type: e.target.value})}>
                        <option value="">-</option>
                        {/* <option value="1">ネコポス</option> */}
                        <option value="2">{t('ship_detail_modal.how2')}</option>
                        <option value="3">{t('ship_detail_modal.how3')}</option>
                        <option value="4">{t('ship_detail_modal.how4')}</option>
                    </select>
                </div>
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.num')}</div>
                <div className="ship-detail-modal-form-content">
                    <input className="ship-detail-modal-form-content-input" type="text" name="tracking_number" value={shipDetail.tracking_number} onChange={e => setShipDetail({...shipDetail, tracking_number: e.target.value})}/>
                </div>
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.single_num')}</div>
                <div className="ship-detail-modal-form-content">
                    <input className="ship-detail-modal-form-content-input" type="text" name="single_tracking_number" value={shipDetail.single_tracking_number} onChange={e => setShipDetail({...shipDetail, single_tracking_number: e.target.value})}/>
                </div>
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.remarks')}</div>
                <div className="ship-detail-modal-form-content">
                    <textarea className="ship-detail-modal-form-content-textarea" name="note" value={shipDetail.note} onChange={e => setShipDetail({...shipDetail, note: e.target.value})}/>
                </div>
            </div>
            <div className="ship-detail-modal-button">
            <button className="ship-detail-modal-button-cancel" onClick={closeModal}>{t('ship_detail_modal.back')}</button>
            <button className="ship-detail-modal-button-add" onClick={moveNextPage}>{t('ship_detail_modal.next')}</button>
            </div>
        </Modal>
        </>
    );
}

const ShipDetailModal2 = ({modalIsOpen, closeModal, completeShip, movePrevPage, shipDetail, setShipDetail}) => {
    const { t } = useTranslation();
    return (
        <>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="ship-detail-modal"
            overlayClassName="ship-detail-modal-overlay"
            contentLabel="Example Modal"
        >
            <div className="ship-detail-modal-title">{t('ship_detail_modal.title')}</div>
            <div className='progressbar-mini-box'>
                <ul className="progressbar-mini">
                    <li className="active"></li>
                    <li className="active"></li>
                </ul>
            </div>
            <div className="clearfix"></div>
            <div className="ship-detail-modal-form">
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.status')}</div>
                <div className="ship-detail-modal-form-content">
                    {shipDetail.status == 1 && <div className="ship-status ship-status-1 ship-detail-status" >{t('ship_detail_modal.status1')}</div>}
                    {shipDetail.status == 2 && <div className="ship-status ship-status-2 ship-detail-status" >{t('ship_detail_modal.status2')}</div>}
                    {shipDetail.status == 3 && <div className="ship-status ship-status-3 ship-detail-status" >{t('ship_detail_modal.status3')}</div>}
                    {shipDetail.status == 4 && <div className="ship-status ship-status-4 ship-detail-status" >{t('ship_detail_modal.status4')}</div>}
                    {shipDetail.status == 5 && <div className="ship-status ship-status-5 ship-detail-status" >{t('ship_detail_modal.status5')}</div>}
                    {shipDetail.status == 6 && <div className="ship-status ship-status-6 ship-detail-status" >{t('ship_detail_modal.status6')}</div>}
                    {shipDetail.status == 7 && <div className="ship-status ship-status-7 ship-detail-status" >{t('ship_detail_modal.status7')}</div>}
                </div>
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.how')}</div>
                <div className="ship-detail-modal-form-content">
                    {[t('ship_detail_modal.how1'), t('ship_detail_modal.how2'), t('ship_detail_modal.how3'), t('ship_detail_modal.how4')][shipDetail.shipment_type - 1]}
                </div>
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.num')}</div>
                <div className="ship-detail-modal-form-content">
                    {shipDetail.tracking_number}
                </div>
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.single_num')}</div>
                <div className="ship-detail-modal-form-content">
                    {shipDetail.single_tracking_number}
                </div>
                <div className="ship-detail-modal-form-title">{t('ship_detail_modal.remarks')}</div>
                <div className="ship-detail-modal-form-content">
                    {shipDetail.note}
                </div>
            </div>
            <div className="line"></div>
            <div className="ship-detail-subtitle">{t('ship_detail_modal.confirm')}</div>
            { shipDetail.status == 3 &&
                <div className="ship-detail-description"><span class="user-mail-note-icon">!</span>  {t('ship_detail_modal.note1')}<br />{t('ship_detail_modal.note2')}<br/>({t('ship_detail_modal.note3')})</div>
            }

            <div className="ship-detail-modal-button">
            <button className="ship-detail-modal-button-cancel" onClick={movePrevPage}>{t('ship_detail_modal.back')}</button>
            <button className="ship-detail-modal-button-add" onClick={completeShip}>{t('ship_detail_modal.change')}</button>
            </div>
        </Modal>
        </>
    );
}